import { Dropdown } from "primereact/dropdown";
import { useEffect, useRef, useState } from "react";
import { Constant } from "../../../constants/constant";
import { useTranslation } from "react-i18next";
import { VariablesConstant } from "../../../constants/variables";
import { Dcs0201Service } from "../../../services/dcs/Dcs0201Service";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { useAppDispatch, useAppSelector } from "../../../store/hook";
import { showAndHideSpinner } from "../../../reducers/spinnerSlice";
import * as XLSX from "xlsx";
import saveAs from "file-saver";
import FunctionButton from "../../../components/layout/FunctionButton";
import AppDialog from "../../../components/commons/AppDialog";
import SelectProVer from "./SelectProVer";


export default function Dcs0201Form(props: any) {
    const [connProtLst, setConnProtLst] = useState<any>(props.connProtLst);
    const lang = useAppSelector((state: any) => state.language.lang);
    const { t } = useTranslation();
    const [dataMap, setDataMap] = useState<any>([{}]);
    const [dataMapName, setDataMapName] = useState<any>(null);
    const [dataItem, setDataItem] = useState<any>();

    // const [lstAdd, setLstAdd] = useState<any>([]);
    // const [lstUpdate, setLstUpdate] = useState<any>([]);
    const [lstDelete, setLstDelete] = useState<any>([]);
    const dispatch = useAppDispatch();
    const [file, setFile] = useState<File | null>(null);
    const [message, setMessage] = useState<string>("");
    const fileInputRef = useRef<HTMLInputElement>(null);
    const [openSelect, setOpenSelect] = useState<any>(false);
    const [sltProtocolVer, setSltProtocolVer] = useState<any>({})
    const regex = /^\S*$/;
    const [checkSpaceColNm, setCheckSpaceColNm] = useState(true)

    useEffect(() => {
        if (props.data) {
            dispatch(showAndHideSpinner(true));
            Dcs0201Service.getInstance()
                .getDataMapById(props.data.dataMapId)
                .then((result: any) => {
                    dispatch(showAndHideSpinner(false));
                    if (result.data.status) {
                        setDataItem(result.data.responseData);
                    }
                });
        }
    }, []);

    // useEffect(() => { console.log(props.data);
    //  }, [props.data]);

    useEffect(() => {
        if (dataItem) {
            setDataMap(dataItem.dataMapping);
            setDataMapName(dataItem.dataMapName);
            setSltProtocolVer({ versionId: dataItem.versionId, protocolName: dataItem.protocolName, protocolVersion: dataItem.protocolVersion })
        }
    }, [dataItem]);

    // const handleChangeProtocol = (value: any) => {
    //     setProtocolSlt(value);
    // };

    const handleChangeDataMap = (event: any, index: any) => {
        setDataMap(
            dataMap.map((item: any, idx: any) =>
                idx === index
                    ? props.data && item.dataMappingId
                        ? {
                            ...item,
                            [event.target.name]: event.target.value,
                            isUpdate: true,
                        }
                        : { ...item, [event.target.name]: event.target.value }
                    : item
            )
        );
    };

    const onAddRow = () => {
        setDataMap([
            ...dataMap,
            {
                isAdd: true,
            },
        ]);
    };

    const onDeleteRow = (index: number) => {
        setLstDelete([
            ...lstDelete,
            dataMap.filter(
                (item: any, idx: any) => idx === index && item.dataMappingId
            )[0],
        ]);
        setDataMap(dataMap.filter((item: any, idx: any) => idx !== index));
    };

    const handleChangeDataMapName = (event: any) => {
        setDataMapName(event.target.value);
    };

    const handleSave = (event: any) => {
        if (props.data) {
            // UPDATE
            const listAdd = dataMap.filter((item: any, idx: any) => item.isAdd);
            const listUpdate = dataMap.filter((item: any, idx: any) => item.isUpdate);
            const listDelete = lstDelete.filter((item: any, idx: any) => item);
            const data = {
                listAdd: listAdd,
                listUpdate: listUpdate,
                listDelete: listDelete,
                dataMapName: dataMapName,
                dataMapId: dataItem.dataMapId,
            };
            if (chk(data, true)) {
                Swal.fire({
                    title: t("dcs0201.message.dialog.confirmUpdate"),
                    showCancelButton: true,
                    confirmButtonText: t("dcs0201.btn.save"),
                    cancelButtonText: t("dcs0201.btn.cancel"),
                }).then((result) => {
                    if (result.isConfirmed) {
                        Dcs0201Service.getInstance()
                            .updateDataMap(data)
                            .then((res) => {
                                if (res.data.status) {
                                    toast.success(
                                        `${t("dcs0201.message.success.updateDataMap")}`
                                    );
                                    props.onClose(true);
                                } else {
                                    toast.error(`${t("dcs0201.message.err.updateDataMap")}`);
                                }
                            });
                    }
                });
            }
        } else {
            // CREATE
            const data = {
                dataMapName: dataMapName,
                connType: sltProtocolVer.versionId,
                dataMap: dataMap,
            };
            if (chk(data, false)) {
                Dcs0201Service.getInstance()
                    .addDataMap(data)
                    .then((res) => {
                        if (res.data.status) {
                            toast.success(`${t("dcs0201.message.success.addDataMap")}`);
                            props.onClose(true);
                        } else {
                            toast.error(`${t("dcs0201.message.err.addDataMap")}`);
                        }
                    });
            }
        }
    };

    function chk(params: any, isEdit: boolean) {
        let _chk = true;
        if (!params.dataMapName || params.dataMapName == null || params.dataMapName.trim() === "") {
            toast.error(`${t("dcs0201.message.required.connNm")}`);
            _chk = false;
        } else if (
            !isEdit &&
            (params.connType == null || Object.keys(params.connType).length === 0)
        ) {
            toast.error(`${t("dcs0201.message.required.connProtTp")}`);
            _chk = false;
        }

        // if (!_chk) {
        //   setModel((prevState: any) => {
        //     return {
        //       ...prevState,
        //       connNm: prevState.connNm || "",
        //       connProtTp: prevState.connProtTp || {},
        //       sltDataMap: prevState.sltDataMap || {},
        //       ip: prevState.ip || "",
        //       port: prevState.port || "",
        //       username: prevState.username || "",
        //       pwd: prevState.pwd || "",
        //       kafkaTopic: prevState.kafkaTopic || "",
        //       dataCycle: prevState.dataCycle || "",
        //       tableNm: prevState.tableNm || "",
        //       slaveId: prevState.slaveId || null,
        //       dataOffset: prevState.dataOffset || null,
        //       quantity: prevState.quantity || null,
        //       clientId: prevState.clientId || "",
        //       topic: prevState.topic || "",
        //       serverName: prevState.serverName || "",
        //       connectionType: prevState.connectionType || {},
        //     };
        //   });
        // }
        return _chk;
    }

    const readExcelFile = (file: File) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            const binaryStr = e.target?.result;
            const workbook = XLSX.read(binaryStr, { type: "binary" });
            const sheetName = workbook.SheetNames[0];
            const sheet = workbook.Sheets[sheetName];
            const parsedData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
            var listTemp = [];
            for (let i = 2; i < parsedData.length; i++) {
                const dataMappingItem = mappingDataImport(parsedData[1], parsedData[i]);
                if (dataMappingItem) {
                    listTemp.push(dataMappingItem);
                } else {
                    Swal.fire(t("dcs0201.message.err.invalidFile"));
                    break;
                }
            }
            setLstDelete([
                ...lstDelete,
                dataMap.filter((item: any, idx: any) => item.dataMappingId)[0],
            ]);
            setDataMap(listTemp);
        };

        reader.readAsBinaryString(file);
    };

    const mappingDataImport = (listHeader: any, listRowData: any) => {
        const result: any = {
            isAdd: true,
        };
        if (
            sltProtocolVer.protocolName === VariablesConstant.PROTOCOL_MODBUS_NAME &&
            listHeader.includes(VariablesConstant.CELL_VAL_COL_NAME) &&
            listHeader.includes(VariablesConstant.CELL_VAL_OFFSET)
        ) {
            //
            for (var i = 0; i < listHeader.length; i++) {
                if (listHeader[i] === VariablesConstant.CELL_VAL_COL_NAME) {
                    result["columnName"] = listRowData[i];
                }
                if (listHeader[i] === VariablesConstant.CELL_VAL_OFFSET) {
                    result["offSet"] = listRowData[i];
                }
            }
        } else if (
            sltProtocolVer.protocolName === VariablesConstant.PROTOCOL_MQTT_NAME &&
            listHeader.includes(VariablesConstant.CELL_VAL_COL_NAME) &&
            listHeader.includes(VariablesConstant.CELL_VAL_FIELD)
        ) {
            for (var i = 0; i < listHeader.length; i++) {
                if (listHeader[i] === VariablesConstant.CELL_VAL_COL_NAME) {
                    result["columnName"] = listRowData[i];
                }
                if (listHeader[i] === VariablesConstant.CELL_VAL_FIELD) {
                    result["field"] = listRowData[i];
                }
            }
        } else if (
            sltProtocolVer.protocolName === VariablesConstant.PROTOCOL_OPC_UA_NAME &&
            listHeader.includes(VariablesConstant.CELL_VAL_COL_NAME) &&
            listHeader.includes(VariablesConstant.CELL_VAL_NS_IDX) &&
            listHeader.includes(VariablesConstant.CELL_VAL_IDENTIFIER)
        ) {
            for (var i = 0; i < listHeader.length; i++) {
                if (listHeader[i] === VariablesConstant.CELL_VAL_COL_NAME) {
                    result["columnName"] = listRowData[i];
                }
                if (listHeader[i] === VariablesConstant.CELL_VAL_NS_IDX) {
                    result["nsIndex"] = listRowData[i];
                }
                if (listHeader[i] === VariablesConstant.CELL_VAL_IDENTIFIER) {
                    result["identifier"] = listRowData[i];
                }
            }
        } else if (
            sltProtocolVer.protocolName === VariablesConstant.PROTOCOL_DNP3_NAME &&
            listHeader.includes(VariablesConstant.CELL_VAL_COL_NAME) &&
            listHeader.includes(VariablesConstant.CELL_VALUE_INDEX)
        ) {
            for (var i = 0; i < listHeader.length; i++) {
                if (listHeader[i] === VariablesConstant.CELL_VAL_COL_NAME) {
                    result["columnName"] = listRowData[i];
                }
                if (listHeader[i] === VariablesConstant.CELL_VALUE_INDEX) {
                    result["indexValue"] = listRowData[i];
                }
            }
        } else if (
            sltProtocolVer.protocolName === VariablesConstant.PROTOCOL_IEC61850_NAME &&
            listHeader.includes(VariablesConstant.CELL_VAL_COL_NAME) &&
            listHeader.includes(VariablesConstant.CELL_PATH_VALUE)
        ) {
            for (var i = 0; i < listHeader.length; i++) {
                if (listHeader[i] === VariablesConstant.CELL_VAL_COL_NAME) {
                    result["columnName"] = listRowData[i];
                }
                if (listHeader[i] === VariablesConstant.CELL_PATH_VALUE) {
                    result["pathValue"] = listRowData[i];
                }
            }
        } else {
            return null;
        }
        return result;
    };

    const handleFileChange = (event: any) => {
        if (event.target.files && event.target.files[0]) {
            const selectedFile = event.target.files[0];
            setFile(selectedFile);
            readExcelFile(selectedFile);
        }
        event.target.value = null;
    };

    const handleUpload = () => {
        if (sltProtocolVer.proId) {
            if (fileInputRef.current) {
                fileInputRef.current.click();
            }
        }else{
            toast.warning(t("dcs0201.message.required.protocol"))
        }

    };


    const exportExcel = () => {
        if (props.data) {
            const param = {
                protocolId: props.data.connType,
                protocolName: dataItem.protocolName,
                dataMapId: props.data.id
            }
            Dcs0201Service.getInstance().exportExcelTemplate(param).then((res) => {
                if (res.data) {
                    const blob = new Blob([res.data], {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    });
                    saveAs(blob, 'data_mapping_template.xlsx');
                }
            });
        }
    }

    const onCloseSelect = (data: any) => {
        if (data) {
            setSltProtocolVer(data)
        }

        setOpenSelect(false)
    }

    const openSelectPro = () => {
        setOpenSelect(true)
    }
    return (
        <>
            <AppDialog
                open={openSelect}
                style={{ width: "30vw" }}
                onClose={onCloseSelect}
                title={
                    "Select Protocol version"
                }
                className="width-dialog">
                <SelectProVer onClose={onCloseSelect} selected={sltProtocolVer} />
            </AppDialog>
            <div className="box">
                <div className="box-body">
                    <div className="form-header mb-3 header-border">
                        <div className="form-header-title">{props.title}</div>
                        <div className="d-flex gap-3">
                            <button className="custom-btn gradient" onClick={handleSave}>
                                <i className="pi pi-save"></i>
                                {t("dcs0201.btn.save")}
                            </button>
                            <button className="custom-btn" onClick={handleUpload}>
                                <i className="pi pi-upload"></i>
                                {t("common.button.label.upload")}
                            </button>
                            <input
                                type="file"
                                accept=".xlsx,.xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
                                ref={fileInputRef}
                                onChange={handleFileChange}
                                style={{ display: 'none' }}
                            />

                            <button className="custom-btn" onClick={exportExcel}>
                                <img style={{ width: "17px" }} src={require("../../../../assets/images/icon/excel.png")} />
                                {t("common.button.label.downloadExcel")}
                            </button>
                            <button className="custom-btn" onClick={() => props.onClose(false)}>
                                {t("sample.label.button.list")}
                            </button>
                        </div>
                    </div>
                    <div className="search-el row">
                        <label className="form-label col-lg-1">
                            {t("dcs0201.form.label.dataMapName")}
                            <strong className="strong-required"> *</strong>
                        </label>
                        <div className="input-search  col-lg-10">
                            <input
                                value={dataMapName || ""}
                                type="text"
                                className="form-control"
                                placeholder={t("dcs0201.form.placeholder.dataMapName")}
                                name="colNm"
                                id="validationInput"
                                onChange={handleChangeDataMapName}
                            />
                            <div className={`${dataMapName?.toString().trim() === "" ? "error-required" : "d-none"}`}>
                                {t("dcs0201.message.required.field")}
                            </div>
                        </div>
                    </div>
                    <div className="search-el row mb-5">
                        <label className="form-label col-lg-1">
                            {" "}
                            {t("dcs0101.label.connectionProtocol")}
                        </label>
                        <div className="input-search col-lg-10">
                            {/* <Dropdown
                                disabled={props.data}
                                value={protocolSlt}
                                onChange={(e: any) => handleChangeProtocol(e.value)}
                                options={connProtLst}
                                optionLabel={
                                    Constant.SOUTH_KOREA === lang
                                        ? Constant.COMM_NM_KR
                                        : Constant.COMM_NM_EN
                                }
                            /> */}
                            <div className="d-flex col-md-3">
                                <input
                                    value={(`${sltProtocolVer.protocolName || ""} ${sltProtocolVer.protocolVersion || ""}`)}
                                    type="text"
                                    readOnly={true}
                                    className="form-control"
                                    name="sltProVer"
                                    id="validationInput"
                                />
                                {!dataItem && <button className="custom-btn mx-2 gradient" onClick={openSelectPro}>
                                    {t("dcs0201.btn.select")}
                                </button>}
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="col-lg-12 mb-3 d-flex justify-content-between">
                            <label className="form-label">
                                {t("dcs0101.form.label.dataMap")}
                            </label>
                            <button className="custom-btn" onClick={onAddRow}>
                                <i className="pi pi-plus"></i>
                                {t("dcs0201.btn.add")}
                            </button>
                        </div>

                        {dataMap &&
                            dataMap.map((data: any, index: any) => (
                                <div className="container-fields mb-3" key={data.id}>
                                    <div className="row-field">
                                        {sltProtocolVer &&
                                            sltProtocolVer.protocolName === VariablesConstant.PROTOCOL_MODBUS_NAME && (
                                                <>
                                                    <label className="data-map-label">
                                                        {t("dcs0101.form.label.offset")}
                                                        <strong className="strong-required"> *</strong>
                                                    </label>
                                                    <div style={{ flex: 1 }}>
                                                        <input
                                                            value={data.offSet}
                                                            type="number"
                                                            className="form-control"
                                                            placeholder={t("dcs0201.form.placeholder.offset")}
                                                            name="offSet"
                                                            id="validationInput"
                                                            onChange={(e) => handleChangeDataMap(e, index)}
                                                        />
                                                        <div
                                                            className={`${data.offSet?.toString().trim() === ""
                                                                ? "error-required"
                                                                : "d-none"
                                                                }`}
                                                        >
                                                            {t("dcs0201.message.required.field")}
                                                        </div>
                                                    </div>
                                                </>
                                            )}
                                        {sltProtocolVer &&
                                            sltProtocolVer.protocolName === VariablesConstant.PROTOCOL_MQTT_NAME && (
                                                <>
                                                    <label className="data-map-label">
                                                        {t("dcs0101.form.label.field")}
                                                        <strong className="strong-required"> *</strong>
                                                    </label>
                                                    <div style={{ flex: 1 }}>
                                                        <input
                                                            value={data.field}
                                                            type="text"
                                                            className="form-control"
                                                            placeholder={t("dcs0201.form.placeholder.field")}
                                                            name="field"
                                                            id="validationInput"
                                                            onChange={(e) => handleChangeDataMap(e, index)}
                                                        />
                                                        <div
                                                            className={`${data.field?.toString().trim() === ""
                                                                ? "error-required"
                                                                : "d-none"
                                                                }`}
                                                        >
                                                            {t("dcs0201.message.required.field")}
                                                        </div>
                                                    </div>
                                                </>
                                            )}
                                        {sltProtocolVer &&
                                            sltProtocolVer.protocolName === VariablesConstant.PROTOCOL_OPC_UA_NAME && (
                                                <>
                                                    <label className="data-map-label">
                                                        {t("dcs0101.form.label.nsIdx")}
                                                        <strong className="strong-required"> *</strong>
                                                    </label>
                                                    <div style={{ flex: 1 }}>
                                                        <input
                                                            value={data.nsIndex}
                                                            type="number"
                                                            className="form-control"
                                                            placeholder={t("dcs0201.form.placeholder.nsIdx")}
                                                            name="nsIndex"
                                                            id="validationInput"
                                                            onChange={(e) => handleChangeDataMap(e, index)}
                                                        />
                                                        <div
                                                            className={`${data.nsIndex?.toString().trim() === ""
                                                                ? "error-required"
                                                                : "d-none"
                                                                }`}
                                                        >
                                                            {t("dcs0201.message.required.field")}
                                                        </div>
                                                    </div>

                                                    <label className="data-map-label">
                                                        {t("dcs0101.form.label.identifier")}
                                                        <strong className="strong-required"> *</strong>
                                                    </label>
                                                    <div style={{ flex: 1 }}>
                                                        <input
                                                            value={data.identifier}
                                                            type="number"
                                                            className="form-control"
                                                            placeholder={t("dcs0201.form.placeholder.identifier")}
                                                            name="identifier"
                                                            id="validationInput"
                                                            onChange={(e) => handleChangeDataMap(e, index)}
                                                        />
                                                        <div
                                                            className={`${data.identifier?.toString().trim() === ""
                                                                ? "error-required"
                                                                : "d-none"
                                                                }`}
                                                        >
                                                            {t("dcs0201.message.required.field")}
                                                        </div>
                                                    </div>
                                                </>
                                            )}
                                        {sltProtocolVer &&
                                            sltProtocolVer.protocolName === VariablesConstant.PROTOCOL_IEC61850_NAME && (
                                                <>
                                                    <label className="data-map-label">
                                                        {t("dcs0201.form.label.pathValue")}
                                                        <strong className="strong-required"> *</strong>
                                                    </label>
                                                    <div style={{ flex: 1 }}>
                                                        <input
                                                            value={data.pathValue}
                                                            type="text"
                                                            className="form-control"
                                                            placeholder={t("dcs0201.form.placeholder.pathValue")}
                                                            name="pathValue"
                                                            id="validationInput"
                                                            onChange={(e) => handleChangeDataMap(e, index)}
                                                        />
                                                        <div
                                                            className={`${data.pathValue?.toString().trim() === ""
                                                                ? "error-required"
                                                                : "d-none"
                                                                }`}
                                                        >
                                                            {t("dcs0201.message.required.field")}
                                                        </div>
                                                    </div>
                                                </>
                                            )}
                                        {sltProtocolVer &&
                                            sltProtocolVer.protocolName === VariablesConstant.PROTOCOL_DNP3_NAME && (
                                                <>
                                                    <label className="data-map-label">
                                                        {t("dcs0201.form.label.index")}
                                                        <strong className="strong-required"> *</strong>
                                                    </label>
                                                    <div style={{ flex: 1 }}>
                                                        <input
                                                            value={data.indexValue}
                                                            type="number"
                                                            className="form-control"
                                                            placeholder={t("dcs0201.form.placeholder.index")}
                                                            name="indexValue"
                                                            id="validationInput"
                                                            onChange={(e) => handleChangeDataMap(e, index)}
                                                        />
                                                        <div
                                                            className={`${data.indexValue?.toString().trim() === ""
                                                                ? "error-required"
                                                                : "d-none"
                                                                }`}
                                                        >
                                                            {t("dcs0201.message.required.field")}
                                                        </div>
                                                    </div>
                                                </>
                                            )}

                                        <label className="data-map-label">
                                            {t("dcs0101.form.label.colNm")}
                                            <strong className="strong-required"> *</strong>
                                        </label>
                                        <div style={{ flex: 1 }}>
                                            <input
                                                value={data.columnName}
                                                type="text"
                                                className="form-control"
                                                placeholder={t("dcs0201.form.placeholder.colNm")}
                                                name="columnName"
                                                id="validationInput"
                                                onChange={(e) => handleChangeDataMap(e, index)}
                                            />
                                            <div
                                                className={`${data.columnName?.toString().trim() === ""
                                                    ? "error-required"
                                                    : "d-none"
                                                    }`}
                                            >
                                                {t("dcs0201.message.required.field")}
                                            </div>
                                            <div
                                                className={`${(data.columnName?.toString().trim() === "" || !regex.test(data.columnName?.toString().trim()))
                                                    ? "error-required"
                                                    : "d-none"
                                                    }`}
                                            >
                                                {t("dcs0201.message.err.notSpace")}
                                            </div>
                                        </div>

                                        <button className="custom-btn border-danger danger" onClick={() => onDeleteRow(index)}>
                                            <i className="pi pi-trash fs-5"></i>
                                            {t("dcs0201.btn.delete")}
                                        </button>
                                    </div>

                                </div>

                            ))
                        }

                    </div>
                </div>
            </div>
            <FunctionButton onAdd={onAddRow} onSave={handleSave} onList={() => props.onClose(false)} currView={VariablesConstant.DATA_MAP_FORM}></FunctionButton>
        </>

    );
}
